module.exports = __webpack_public_path__ + "static/media/remove.b34ce02f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/remove.svg
// module id = 1000
// module chunks = 0